export default __webpack_public_path__ + "static/media/shortmotivational_icon.9378771a.svg";